/*
 * Copyright (C) 2017 Spanning Cloud Apps. LLC  All rights reserved.
 */
import './checkboxButton.tpl.html';
import './checkboxButton.scss';

(function () {
  angular
    .module('shared.checkboxButton', [])
    .directive('sbsfCheckboxButton', directive)
    .controller('CheckboxButtonCtrl', ['$scope', controller]);

  /**
   * Defines the sbsf-checkbox-button directive.
   *
   * @returns {Object} - The directive settings
   */
  function directive() {
    return {
      controller: 'CheckboxButtonCtrl',
      templateUrl: 'shared/checkboxButton/checkboxButton.tpl.html',
      restrict: 'E',
      transclude: true,
      scope: {
        checked: '=',
        onClick: '&',
        disabled: '='
      }
    };
  }

  /**
   * The controller for the directive.
   */
  function controller($scope) {
    $scope.onClickWrapper = function (event) {
      if (!$scope.disabled) {
        $scope.onClick(event);
      }
    };
  }
})();
